<template>
  <div class="main-menu-bar">
    <div class="main-menu-item" v-for="(item, index) in mainMenuItems" :key="index"
         @mouseenter="onMenuEnter(index)" @mouseleave="onMenuLeave()">
      <a @click="handleMenuClick(item)" class="menu-link" href="javascript:void(0)">
        <img :src="hoveredIndex === index ? item.hoverIcon : item.icon" 
             :alt="item.name" class="menu-icon" />
        <span class="menu-text">{{ item.name }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainMenuBar',
  props: {
    mainMenuItems: {
      type: Array,
      required: true,
      default: () => []
    },
    hoveredIndex: {
      type: Number,
      default: null
    },
    user: {
      type: [Object, Array],
      default: () => null
    }
  },
  data() {
    return {
      protectedRoutes: ['/cashback', '/event', '/partner', '/continue']
    }
  },
  methods: {
    onMenuEnter(index) {
      this.$emit('menu-enter', index)
    },
    onMenuLeave() {
      this.$emit('menu-leave')
    },
    handleMenuClick(item) {
      const isProtected = this.protectedRoutes.includes(item.path)
      const isLoggedIn = this.user && (Array.isArray(this.user) ? this.user.length > 0 && this.user[0].key : this.user.key)
      
      if (isProtected && !isLoggedIn) {
        // Show login modal for protected routes when not logged in
        const loginModal = document.getElementById('loginModal')
        if (loginModal) {
          const modal = new bootstrap.Modal(loginModal)
          modal.show()
        } else {
          // Fallback: try jQuery if bootstrap is not available
          if (window.$ && window.$('#loginModal').length) {
            window.$('#loginModal').modal('show')
          } else {
            // Final fallback: trigger modal via data attributes
            const modalTrigger = document.querySelector('[data-target="#loginModal"]')
            if (modalTrigger) {
              modalTrigger.click()
            }
          }
        }
      } else {
        // Navigate to route (either public route or user is logged in)
        this.$router.push(item.path)
      }
    }
  }
}
</script>

<style scoped>
.main-menu-bar {
  top: 0;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* min-height: 180px; */
}

.main-menu-item {
  width: 157px;
  height: 157px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
}

.main-menu-item:hover {
  transform: translateY(-3px);
}

.menu-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.3s ease;
}

.menu-link:hover {
  color: #000000;
  text-decoration: none;
  cursor: pointer;
}

.menu-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 0;
}

.menu-text {
  display: none;
}
</style>